//
// linked-text.js
//
// Copyright (c) 2016 by Curalate, Inc.
//

/* global angular: false */

((() => {
    const curalate = angular.module('curalate');

    curalate.directive('linkedText', () => ({
        restrict: 'E',

        scope: {
            link: '@',
            text: '@?',
        },

        templateUrl: '/app/components/common/linked-text/linked-text.html',

        link(scope) {
            scope.model = {};
            scope.model.isLink = link => !!link && link.toString().startsWith('http');
        },
    }));
}))();

